export default theme => ({
  container: {
    backgroundColor: theme.palette.common.white,
    width: '100%',
    position: 'relative',
    zIndex: 1,
    display: 'table',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  videoContainer: {
    display: 'table-cell',
    width: '50%',
    position: 'relative',
    backgroundRepeat: 'repeat',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
      height: 350,
    },
  },
  videoButton: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 3,
    top: 0,
    left: 0,
    fontSize: 'calc(3vw + 3vh + 50px)',
    color: theme.palette.grey[800],
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  textContainer: {
    display: 'table-cell',
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
    },
    '& u': {
      textDecorationColor: theme.palette.yellow.main,
    },
  },
  p1Text: {
    fontWeight: 700,
    paddingBottom: theme.spacing(2),
  },
  p1Source: {
    fontWeight: 700,
    paddingBottom: theme.spacing(4),
  },
  p2: {
    paddingBottom: theme.spacing(3),
  },
  p2Text: {
    paddingBottom: theme.spacing(2),
    fontSize: '1.05rem',
  },
  p2Li: {
    fontWeight: 300,
    paddingBottom: theme.spacing(1),
  },
  p2Puce: {
    color: theme.palette.yellow.main,
    fontWeight: 700,
    marginLeft: theme.spacing(2),
  },
  p3: {
    paddingBottom: theme.spacing(4),
  },
  dialogPaper: {
    position: 'relative',
    padding: theme.spacing(5),
    overflow: 'hidden',
    backgroundColor: theme.palette.grey.main,
    color: theme.palette.common.white,
    height: '90vh',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      padding: theme.spacing(2),
      width: `calc(100% - ${theme.spacing(2)}px)`,
    },
  },
  dialogContent: {
    padding: 0,
    paddingBottom: theme.spacing(2),
    height: '100%',
  },
  dialogClose: {
    position: 'absolute',
    right: -5,
    top: -5,
    zIndex: 4,
    [theme.breakpoints.down('sm')]: {
      top: -10,
      right: -10,
    },
  },
});
